import i18n from '@/plugins/i18n.js';

/*
 * Procédure pour créer une arborescence à 2 niveaux, contrôlée par 'profil' (groupe) ou 'platform' :
 * {
 *   name: "Niveau1",
 *   attributes: {
 *      hidden: false,
 *      platforms: ['PLF1,'PLF2'],
 *   }
 *   children: [
 *     {
 *        name: "Niveau2a",
 *        ...
 *     },
 *     {
 *        name: "Niveau2b",
 *        ...
 *     },
 *   ]
 * }
 *
 * Dans l'exemple ci-dessus, il faut :
 *   - placer un 'attributes' au niveau 1, avec hidden: false, 
 *   - placer un 'platforms' avec la liste des plateformes des niveaux inférieurs
 * 
 * Lors de l'affectation des droits (refresh_nav.js), si aucun des Niveaux 2 n'est autorisé,
 * le script va 'renommer' (copier/supprimer) le 'children' du Niveau 1 en 'alt_children'
 * Par ce biais, le menu, qui batit des cascades de 'SidebarNavDropdown' batira des 'SidebarNavItem'/'SidebarNavLink'
 * et utilisera leur propriété 'hidden'.
 * (voir : front/node_modules/@coreui/vue/src/components/Sidebar/*.vue)
 * 
 */

export default {
   items: [
      {
         title: true,
         name: i18n.t('nav.ddo_extranet'),
         class: '',
         wrapper: {
            element: '',
            attributes: {}
         },
      },

      {
         name: i18n.t('nav.dashboard'),
         class: '',
         url: '/dashboard',
         icon: 'icon-speedometer',
         attributes: {
            profiles: 'role_customer role_reseller group_ddo_technique group_ddo_commercial group_ddo_administratif group_ddo_direction',
         },
      },

      {
         name: i18n.t('nav.myprofile'),
         class: '',
         url: '/myprofile',
         icon: 'icon-user',
      },

      {
         name: i18n.t('nav.mycompany'),
         class: '',
         url: '/mycompany',
         icon: 'icon-briefcase',
         attributes: {
            disabled: false,
         },
      },

      {
         name: i18n.t('nav.cus'),
         class: '',
         url: '/customerreseller',
         icon: 'icon-people',
         attributes: {
            profiles: 'role_reseller group_ddo_technique group_ddo_commercial group_ddo_administratif group_ddo_direction',
            hidden: true,
         },
      },

      {
         name: i18n.t('nav.catalog'),
         class: '',
         url: '/catalog',
         icon: 'icon-user',
         attributes: {
            disabled: false,
            hidden: true,
         },
      },

      {
         name: i18n.t('nav.plf'),
         class: '',
         icon: 'icon-puzzle',
         attributes: {
            lookChildren: true,
            hidden: false,
            platforms: ['SMTP-PRO','SMS-PRO','BAREOS'],
         },
         children: [
            {
               class: '',
               name: i18n.t('nav.monitoring_customerservicesmtppro'),
               url: '/platform/servicesmtppro',
               icon: 'icon-speedometer',
               attributes: {
                  profiles: 'group_ddo_technique group_ddo_commercial group_ddo_administratif group_ddo_direction',
                  platforms: ['SMTP-PRO'],
                  hidden: false,
               },
            },
            {
               class: '',
               name: i18n.t('nav.monitoring_customerservicesmspro'),
               url: '/platform/servicesmspro',
               icon: 'icon-speedometer',
               attributes: {
                  profiles: 'group_ddo_technique group_ddo_commercial group_ddo_administratif group_ddo_direction',
                  platforms: ['SMS-PRO'],
                  hidden: false,
               },
            },
            {
               class: '',
               name: i18n.t('nav.monitoring_customerservicebackupbareos'),
               url: '/platform/servicebackupbareos',
               icon: 'icon-speedometer',
               attributes: {
                  profiles: 'group_ddo_technique group_ddo_commercial group_ddo_administratif group_ddo_direction',
                  platforms: ['BAREOS'],
                  hidden: false,
               },
            },
         ]
      },

      {
         name: i18n.t('nav.monitoring'),
         class: '',
         icon: 'icon-puzzle',
         attributes: {
            lookChildren: true,
            profiles: 'group_ddo_technique group_ddo_commercial group_ddo_administratif group_ddo_direction',
            hidden: true,
         },
         
         children: [
            {
               name: i18n.t('nav.monitoring_log'),
               url: '/monitoring/log',
               icon: 'icon-speedometer',
               attributes: {
                  platforms: ['ADMIN'],
                  hidden: true,
               },
            },
            {
               name: i18n.t('nav.monitoring_customerservicesmtppro'),
               url: '/monitoring/customerservicesmtppro',
               icon: 'icon-speedometer',
               attributes: {
                  platforms: ['SMTP-PRO'],
                  hidden: true,
               },
            },
            {
               name: i18n.t('nav.monitoring_racks_in_dc'),
               url: '/monitoring/datacenters',
               icon: 'icon-speedometer',
               attributes: {
                  platforms: ['ADMIN'],
                  hidden: true,
               },
            },
            {
               name: i18n.t('nav.monitoring_certificatedeployments'),
               url: '/monitoring/certificatedeployments',
               icon: 'icon-speedometer',
               attributes: {
                  platforms: ['CERTIFICATES'],
                  hidden: true,
               },
            },
            {
               name: i18n.t('nav.monitoring_customercontacts'),
               url: '/monitoring/customercontacts',
               icon: 'icon-people',
               attributes: {
                  platforms: ['ADMIN'],
                  hidden: true,
               },
            },
         ]
         
      },

      {
         name: i18n.t('nav.plf_admin'),
         class: '',
         icon: 'icon-settings',
         attributes: {
            profiles: 'group_ddo_administratif group_ddo_technique role_superadmin group_ddo_direction',
            hidden: false,
         },
         
         children: [

            {
               name: i18n.t('nav.inv'),
               url: '/admin/invoice',
               icon: 'icon-wallet',
               attributes: {
                  hidden: false,
               },
            },     
            {
               name: i18n.t('nav.prc'),
               class: '',
               url: '/admin/product',
               icon: 'icon-diamond',
               attributes: {
                  hidden: false,
               },
            },

            {
               name: i18n.t('nav.reseller'),
               url: '/admin/reseller',
               icon: 'icon-puzzle',
               attributes: {
                  disabled: false,
                  hidden: false,
               },
            },
            {
               name: i18n.t('nav.identities'),
               url: '/admin/ldapusers',
               icon: 'icon-people',
               attributes: {
                  hidden: false,
               },
               badge: {
                  variant: 'danger',
                  text: 'new'
               }
            },
            {
               name: i18n.t('nav.sla'),
               url: '/admin/sla',
               icon: 'icon-list',
               attributes: {
                  hidden: false,
               },
               badge: {
                  variant: 'danger',
                  text: 'new'
               }
            },
            {
               name: i18n.t('nav.cer'),
               url: '/admin/certificate',
               icon: 'icon-puzzle',
               attributes: {
                  hidden: false,
               },
               badge: {
                  variant: 'danger',
                  text: 'new'
               }
            },
         
         {
            name: i18n.t('nav.infra'),
            icon: 'icon-wrench',
            attributes: {
               platforms: ['ADMIN'],
               hidden: false,
            },
            children: [
               {
                  name: i18n.t('nav.equ'),
                  url: '/admin/infra/equipment',
                  icon: 'icon-puzzle',
                  badge: {
                     variant: 'danger',
                     text: 'new'
                  }
               },
               {
                  name: i18n.t('nav.vla'),
                  url: '/admin/infra/vlan',
                  icon: 'icon-puzzle',
                  badge: {
                     variant: 'danger',
                     text: 'new'
                  }
               },
                  {
                  name: i18n.t('nav.net'),
                  url: '/admin/infra/network',
                  icon: 'icon-puzzle',
                  badge: {
                     variant: 'danger',
                     text: 'new'
                  }
               },
            ]
         },
         
         {
            name: i18n.t('nav.settings'),
            url: '/admin/settings',
            icon: 'icon-settings',
            attributes: {
               platforms: ['ADMIN'],
               hidden: false,
               lookChildren: true,
            },
            children: [
               {
                  name: i18n.t('nav.shc'),
                  url: '/admin/settings/shortcode',
                  icon: 'icon-puzzle',
                  attributes: {
                     platforms: ['ADMIN'],
                     hidden: false,
                  },
               },     
               {
                  name: i18n.t('nav.zohoconv'),
                  url: '/admin/settings/exportszoho',
                  icon: 'icon-puzzle',
                  attributes: {
                     platforms: ['ADMIN'],
                     hidden: false,
                  },
               },     
            ]
         },
         
         ]
      },

      {
         name: i18n.t('nav.logout'),
         url: '/pages/logout',
         icon: 'icon-user',
      },
   ]
}
